/* ==========================================================================
   TP Header 2.0 — Navigation 2.0
   Megameny (hover-intent + klick + tangentbord), sökpanel, mobil drilldown,
   scrollbeteende, favoriträknare och TP Club-modal.

   Bevarade kontrakt:
     · body.tp-search-open / body.tp-mobile-drawer-open / body.tp-club-modal-open
     · favoriter: localStorage 'tp_favorite_products_v1', event 'tp:favorites-updated',
       [data-tp-favorites-link] / [data-tp-favorites-count] / .has-favorites
     · TP Club: samma auto-popup-regler och lagringsnycklar som tidigare header
       ('tpClubAutoPopupLastShown', 'tpClubAutoPopupShownThisSession'), öppnas
       inte när varukorgslåda, sök eller mobilmeny är öppen.
   ========================================================================== */
(function () {
  'use strict';

  var mqDesktop = window.matchMedia('(min-width: 990px)');

  /* ------------------------------------------------------------------
     Fokusram bara for tangentbord.

     :focus-visible racker inte hela vagen: nar en lucka stangs flyttas
     fokus tillbaka till knappen som oppnade den (det ska den gora), och
     programmatisk fokus ger ram aven efter ett fingertryck. Resultatet var
     en fyrkant runt varukorgen, menyn, sokglaset och X.

     Vi markerar darfor dokumentet medan senaste inmatningen kom fran
     pekdon och slapper markeringen sa fort nagon tabbar. CSS:en i
     tp-tokens.css doljer ramen pa knappar i det laget — textfalt behaller
     sin, de behover den.
     ------------------------------------------------------------------ */
  (function bindInputModality() {
    var root = document.documentElement;
    if (root.dataset.tpModality === 'true') return;
    root.dataset.tpModality = 'true';

    function pointerUsed() {
      root.classList.add('tp-using-pointer');
    }

    function keyUsed(event) {
      if (event.key === 'Tab' || event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        root.classList.remove('tp-using-pointer');
      }
    }

    document.addEventListener('pointerdown', pointerUsed, true);
    document.addEventListener('touchstart', pointerUsed, { capture: true, passive: true });
    document.addEventListener('mousedown', pointerUsed, true);
    document.addEventListener('keydown', keyUsed, true);
  })();

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatPrice(value) {
    if (value == null || value === '') return '';
    var num = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
    if (!isFinite(num)) return typeof value === 'string' ? value : '';
    var hasOre = Math.round(num * 100) % 100 !== 0;
    return num.toLocaleString('sv-SE', { minimumFractionDigits: hasOre ? 2 : 0, maximumFractionDigits: hasOre ? 2 : 0 }) + ' kr';
  }

  function productImage(product) {
    if (!product) return '';
    if (typeof product.image === 'string') return product.image;
    if (product.image && product.image.url) return product.image.url;
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    return '';
  }

  function initShell(shell) {
    if (!shell || shell.dataset.tp2Ready === 'true') return;
    shell.dataset.tp2Ready = 'true';

    var section = shell.parentElement;
    if (section) {
      section.classList.add('tp2-section');
      if (shell.dataset.tp2Overlay === 'true') section.classList.add('tp2-section--overlay');
    }

    var header = shell.querySelector('[data-tp2-header]');
    var stickyMode = shell.dataset.tp2StickyMode || 'always';

    /* ------------------------------------------------------------------
       Gemensamt tillstånd
       ------------------------------------------------------------------ */
    var state = { mega: null, search: false, drawer: false };

    function syncOpen() {
      var open = !!state.mega || state.search;
      shell.classList.toggle('is-open', open);
      if (open) shell.classList.remove('is-hidden');
    }

    /* Meddelar övriga lager att ett lager öppnats (se tp:layer-open nedan). */
    function announceLayer(name) {
      document.dispatchEvent(new CustomEvent('tp:layer-open', { detail: { name: name } }));
    }

    /* ------------------------------------------------------------------
       Megameny
       ------------------------------------------------------------------ */
    var megaItems = Array.prototype.slice.call(shell.querySelectorAll('[data-tp2-mega-item]'));
    var openTimer = null;
    var closeTimer = null;

    function closeMega() {
      if (!state.mega) return;
      var item = state.mega;
      var trigger = item.querySelector('[data-tp2-mega-trigger]');
      var panel = item.querySelector('[data-tp2-mega]');
      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.classList.remove('is-open');
        panel.hidden = true;
      }
      state.mega = null;
      syncOpen();
    }

    function openMega(item) {
      if (state.mega === item) return;
      closeMega();
      if (state.search) closeSearch();
      var trigger = item.querySelector('[data-tp2-mega-trigger]');
      var panel = item.querySelector('[data-tp2-mega]');
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.hidden = false;
        panel.classList.add('is-open');
        fitMega(panel);
        resetPreview(panel);
      }
      state.mega = item;
      syncOpen();
    }

    /* Headerns underkant mäts när panelen öppnas, så att CSS kan låta
       panelen sluta vid fönstrets nederkant även när meddelandefältet
       ligger ovanför headern (överst på sidan). Headern mäts i stället för
       panelen, eftersom panelens inglidning flyttar den en aning. */
    function fitMega(panel) {
      var host = panel.offsetParent || panel.parentNode;
      var hostRect = host.getBoundingClientRect();
      var top = Math.max(0, Math.round(hostRect.bottom));
      panel.style.setProperty('--tp2-mega-top', top + 'px');

      /* Menyn "Mer" är en smal panel som ska börja under sin egen rubrik,
         men aldrig sticka ut utanför fönstret. */
      if (panel.classList.contains('tp2-mega--menu')) {
        var item = panel.closest('[data-tp2-mega-item]');
        var trigger = item && item.querySelector('[data-tp2-mega-trigger]');
        if (!trigger) return;
        var edge = 16;
        var width = panel.offsetWidth;
        var left = trigger.getBoundingClientRect().left - hostRect.left - edge;
        var max = hostRect.width - width - edge;
        left = Math.max(edge, Math.min(left, max));
        panel.style.setProperty('--tp2-menu-x', Math.round(left) + 'px');
      }
    }

    /* ------------------------------------------------------------------
       Megamenyns förhandsvisning

       Panelens högerspalt visar tre produkter ur den kategori muspekaren
       vilar på — eller som har tangentbordsfokus. Svaret kommer från
       kategorins egen vy (?view=tp-menu) och sparas, så varje kategori
       hämtas högst en gång per sidvisning. När panelen öppnas visas
       huvudpunktens egen kategori.

       Byte sker först när pekaren stannat en kort stund på en länk. På
       väg från en länk till produkterna passerar pekaren andra länkar;
       den som lämnar länkarna och går in i högerspalten avbryter därför
       ett väntande byte, så att förhandsvisningen står still när man
       sträcker sig efter den.
       ------------------------------------------------------------------ */
    var previewCache = {};
    var previewRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function collectionHandle(url) {
      var match = /\/collections\/([^/?#]+)/.exec(url || '');
      return match ? match[1] : '';
    }

    function loadPreview(handle) {
      if (!previewCache[handle]) {
        previewCache[handle] = fetch(previewRoot + 'collections/' + encodeURIComponent(handle) + '?view=tp-menu', {
          credentials: 'same-origin'
        })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .catch(function () {
            delete previewCache[handle];
            return '';
          });
      }
      return previewCache[handle];
    }

    function showPreview(preview, url, label, link) {
      var handle = collectionHandle(url);
      if (!handle || preview.tp2Handle === handle) return;
      preview.tp2Handle = handle;
      var ticket = (preview.tp2Ticket || 0) + 1;
      preview.tp2Ticket = ticket;

      var panel = preview.closest('[data-tp2-mega]');
      if (panel) {
        Array.prototype.forEach.call(panel.querySelectorAll('.tp2-mega__link.is-previewed'), function (el) {
          el.classList.remove('is-previewed');
        });
      }
      if (link) link.classList.add('is-previewed');

      preview.classList.add('is-loading');
      loadPreview(handle).then(function (html) {
        if (preview.tp2Ticket !== ticket) return;
        preview.classList.remove('is-loading');

        var holder = document.createElement('div');
        holder.innerHTML = html;
        var data = holder.querySelector('[data-tp2-pv-data]');
        var items = data ? data.querySelectorAll('.tp2-mega__pv-item') : [];
        var grid = preview.querySelector('[data-tp2-pv-grid]');
        var title = preview.querySelector('[data-tp2-pv-title]');
        var kicker = preview.querySelector('[data-tp2-pv-kicker]');
        var all = preview.querySelector('[data-tp2-pv-link]');
        var count = data ? parseInt(data.getAttribute('data-count'), 10) || 0 : 0;

        if (title) title.textContent = label;
        if (kicker && data) kicker.textContent = data.getAttribute('data-kicker') || kicker.textContent;
        if (all) {
          all.href = url;
          all.textContent = count ? 'Visa alla ' + count : 'Visa alla';
        }
        if (!grid) return;
        if (!items.length) {
          preview.classList.add('is-empty');
          grid.innerHTML = '';
          return;
        }
        preview.classList.remove('is-empty');
        grid.innerHTML = '';
        Array.prototype.forEach.call(items, function (li) {
          grid.appendChild(li);
        });
      });
    }

    function resetPreview(panel) {
      var preview = panel.querySelector('[data-tp2-preview]');
      if (!preview) return;
      preview.tp2Handle = '';
      showPreview(preview, preview.getAttribute('data-default-url'), preview.getAttribute('data-default-label') || '', null);
    }

    Array.prototype.forEach.call(shell.querySelectorAll('[data-tp2-preview]'), function (preview) {
      var panel = preview.closest('[data-tp2-mega]');
      if (!panel) return;
      var side = preview.closest('.tp2-mega__side') || preview;
      var waiting = null;

      function linkFrom(target) {
        var link = target && target.closest ? target.closest('a.tp2-mega__link') : null;
        if (!link || !panel.contains(link) || side.contains(link)) return null;
        return collectionHandle(link.getAttribute('href')) ? link : null;
      }

      panel.addEventListener('pointerover', function (event) {
        if (side.contains(event.target)) {
          clearTimeout(waiting);
          return;
        }
        var link = linkFrom(event.target);
        if (!link) return;
        clearTimeout(waiting);
        waiting = setTimeout(function () {
          showPreview(preview, link.getAttribute('href'), link.textContent.trim(), link);
        }, 110);
      });

      panel.addEventListener('focusin', function (event) {
        var link = linkFrom(event.target);
        if (!link) return;
        clearTimeout(waiting);
        showPreview(preview, link.getAttribute('href'), link.textContent.trim(), link);
      });
    });

    megaItems.forEach(function (item) {
      var trigger = item.querySelector('[data-tp2-mega-trigger]');
      if (!trigger) return;

      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'mouse' || !mqDesktop.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { openMega(item); }, 70);
      });

      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          if (state.mega === item) closeMega();
        }, 160);
      });

      trigger.addEventListener('click', function () {
        clearTimeout(openTimer);
        if (state.mega === item) closeMega();
        else openMega(item);
      });

      item.addEventListener('focusout', function (event) {
        if (state.mega !== item) return;
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        if (!event.relatedTarget) return; /* klick på icke-fokuserbart — pointerdown sköter det */
        closeMega();
      });
    });

    document.addEventListener('pointerdown', function (event) {
      if (state.mega && header && !header.contains(event.target)) closeMega();
    });

    mqDesktop.addEventListener('change', function () {
      closeMega();
    });

    /* ------------------------------------------------------------------
       Sökpanel
       ------------------------------------------------------------------ */
    var searchPanel = shell.querySelector('[data-tp2-search]');
    var searchInput = shell.querySelector('[data-tp2-search-input]');
    var searchResults = shell.querySelector('[data-tp2-search-results]');
    var searchDefault = shell.querySelector('[data-tp2-search-default]');
    var searchClear = shell.querySelector('[data-tp2-search-clear]');
    var searchTimer = null;
    var lastQuery = '';
    var lastFocus = null;

    /* Ett sökfält på desktop (P2-10). Headern har ett brett sökfält och
       panelen hade ett eget under det — två fält samtidigt. När det breda
       fältet syns flyttas panelens formulär in på dess plats medan panelen
       är öppen, och tillbaka när den stängs. Det är samma element, så
       lyssnare, fokus och inskick följer med. */
    var headerField = shell.querySelector('.tp2-header__search');
    var searchForm = searchPanel ? searchPanel.querySelector('.tp2-search__form') : null;
    var searchFormHome = searchForm ? searchForm.parentNode : null;
    var searchFormNext = searchForm ? searchForm.nextElementSibling : null;

    function dockSearchForm(dock) {
      if (!headerField || !searchForm || !searchFormHome) return;
      if (dock) {
        headerField.insertAdjacentElement('afterend', searchForm);
        headerField.hidden = true;
        searchForm.classList.add('is-docked');
      } else if (searchForm.classList.contains('is-docked')) {
        searchFormHome.insertBefore(searchForm, searchFormNext);
        headerField.hidden = false;
        searchForm.classList.remove('is-docked');
      }
    }

    function resetSearch() {
      lastQuery = '';
      if (searchInput) searchInput.value = '';
      if (searchClear) searchClear.hidden = true;
      if (searchDefault) searchDefault.hidden = false;
      if (searchResults) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
      }
    }

    function openSearch(trigger) {
      if (!searchPanel || state.search) return;
      closeMega();
      closeDrawer();
      lastFocus = trigger || document.activeElement;
      state.search = true;
      if (headerField && window.getComputedStyle(headerField).display !== 'none') dockSearchForm(true);
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tp-search-open');
      syncOpen();
      announceLayer('search');

      /* Tangentbordet ska upp direkt nar man trycker pa forstoringsglaset.

         Fokus lag tidigare i en requestAnimationFrame, alltsa i nasta
         bildruta. iOS oppnar bara tangentbordet nar focus() anropas i samma
         handelse som beroringen — en bildruta senare ar for sent, och da
         oppnades panelen utan att man kunde borja skriva.

         Panelen ar display:none tills .is-open satts, och ett dolt falt gar
         inte att fokusera. Darfor tvingas layouten fram forst (offsetHeight)
         sa att faltet finns nar focus() anropas, fortfarande inne i
         klickhandelsen. requestAnimationFrame ligger kvar som reserv for de
         fall dar det forsta forsoket inte gick igenom. */
      if (searchInput) {
        void searchPanel.offsetHeight;
        try {
          searchInput.focus({ preventScroll: true });
        } catch (e) {
          searchInput.focus();
        }
      }

      window.requestAnimationFrame(function () {
        if (searchInput && document.activeElement !== searchInput) searchInput.focus();
      });
    }

    /* options.quiet: ett annat lager tar över och flyttar själv fokus. */
    function closeSearch(options) {
      if (!searchPanel || !state.search) return;
      state.search = false;
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tp-search-open');
      resetSearch();
      dockSearchForm(false);
      syncOpen();
      if (!(options && options.quiet) && lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    function renderResults(products, query) {
      if (!searchResults || !searchDefault) return;
      searchDefault.hidden = true;
      searchResults.hidden = false;
      var safeQuery = escapeHtml(query);
      var heading = '<p class="tp2-search__results-heading">Sökresultat för <strong>“' + safeQuery + '”</strong></p>';

      if (!products.length) {
        searchResults.innerHTML = heading + '<p class="tp2-search__empty">Inga produkter hittades. Prova ett annat ord eller en kategori.</p>';
        return;
      }

      var cards = products.map(function (product) {
        var image = productImage(product);
        var title = product.title || '';
        var price = formatPrice(product.price || product.price_min || product.price_max || '');
        var url = product.url || '#';
        return (
          '<a href="' + escapeHtml(url) + '" class="tp2-search__result">' +
            '<span class="tp2-search__result-media">' +
              (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" decoding="async" width="112" height="112">' : '') +
            '</span>' +
            '<span>' +
              '<span class="tp2-search__result-title">' + escapeHtml(title) + '</span>' +
              (price ? '<span class="tp2-search__result-price">' + escapeHtml(price) + '</span>' : '') +
            '</span>' +
          '</a>'
        );
      }).join('');

      var all = '<a class="tp2-search__all" href="/search?q=' + encodeURIComponent(query) + '&type=product">Visa alla resultat →</a>';
      searchResults.innerHTML = heading + '<div class="tp2-search__results-grid">' + cards + '</div>' + all;
    }

    function runSearch() {
      if (!searchInput) return;
      var query = searchInput.value.trim();
      if (searchClear) searchClear.hidden = query.length === 0;

      if (!query.length) {
        lastQuery = '';
        if (searchDefault) searchDefault.hidden = false;
        if (searchResults) {
          searchResults.hidden = true;
          searchResults.innerHTML = '';
        }
        return;
      }

      lastQuery = query;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last')
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (query !== lastQuery) return;
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, query);
        })
        .catch(function () {
          if (query !== lastQuery || !searchResults || !searchDefault) return;
          searchDefault.hidden = true;
          searchResults.hidden = false;
          searchResults.innerHTML = '<p class="tp2-search__empty">Kunde inte ladda sökresultat just nu.</p>';
        });
    }

    shell.querySelectorAll('[data-tp2-search-open]').forEach(function (button) {
      button.addEventListener('click', function () { openSearch(button); });
    });

    shell.querySelectorAll('[data-tp2-search-close]').forEach(function (button) {
      button.addEventListener('click', closeSearch);
    });

    /* Skärmen bakom sök och megameny stänger dem vid klick. Knappen fanns
       men hade ingen lyssnare. */
    var scrim = shell.querySelector('[data-tp2-scrim]');
    if (scrim) {
      scrim.addEventListener('click', function () {
        closeSearch();
        closeMega();
      });
    }

    if (searchClear) {
      searchClear.addEventListener('click', function () {
        resetSearch();
        if (searchInput) searchInput.focus();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(runSearch, 120);
      });
    }

    /* ------------------------------------------------------------------
       Mobilmeny — drilldown
       ------------------------------------------------------------------ */
    var drawer = shell.querySelector('[data-tp2-drawer]');
    var drawerRoot = drawer ? drawer.querySelector('[data-tp2-level="root"]') : null;
    var drawerOpeners = shell.querySelectorAll('[data-tp2-drawer-open]');
    var drawerLastFocus = null;
    var activeLevel = null;
    var drawerViewport = drawer ? drawer.querySelector('[data-tp2-drawer-viewport]') : null;

    /* Fokus i en panel som ligger utanför viewportens box får inte scrolla
       overflow-behållaren i sidled (overflow: clip i CSS + preventScroll här). */
    function resetViewportScroll() {
      if (drawerViewport) drawerViewport.scrollLeft = 0;
    }

    /* Nivaerna ligger i en stack, inte i en variabel. Tillbaka gar alltid
       ett steg — aldrig hela vagen ut — och samma funktion anvands av
       bakatknappen, Escape och kantsvepet. */
    var levelStack = [];

    function drillBack() {
      var level = levelStack.pop();
      if (!level) return;
      level.classList.remove('is-active');
      level.setAttribute('aria-hidden', 'true');

      var parent = levelStack[levelStack.length - 1] || null;
      activeLevel = parent;
      if (parent) {
        parent.classList.add('is-active');
        parent.setAttribute('aria-hidden', 'false');
      }
      if (drawerRoot) drawerRoot.classList.toggle('is-behind', levelStack.length > 0);

      var id = level.dataset.tp2Level;
      var parentButton = drawer.querySelector('[data-tp2-drill="' + id + '"]');
      if (parentButton) parentButton.focus({ preventScroll: true });
      resetViewportScroll();
    }

    function resetLevels() {
      levelStack.forEach(function (level) {
        level.classList.remove('is-active');
        level.setAttribute('aria-hidden', 'true');
      });
      levelStack = [];
      activeLevel = null;
    }

    function drillTo(id) {
      if (!drawer) return;
      var level = drawer.querySelector('[data-tp2-level="' + id + '"]');
      if (!level) return;
      if (levelStack.indexOf(level) > -1) return;

      var previous = levelStack[levelStack.length - 1];
      if (previous) previous.classList.remove('is-active');

      levelStack.push(level);
      activeLevel = level;
      level.scrollTop = 0;
      level.classList.add('is-active');
      level.setAttribute('aria-hidden', 'false');
      if (drawerRoot) drawerRoot.classList.add('is-behind');
      var back = level.querySelector('[data-tp2-drill-back]');
      if (back) window.requestAnimationFrame(function () {
        back.focus({ preventScroll: true });
        resetViewportScroll();
      });
    }

    function openDrawer(trigger) {
      if (!drawer || state.drawer) return;
      closeMega();
      closeSearch();
      drawerLastFocus = trigger || document.activeElement;
      state.drawer = true;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      /* Korten överst hämtas direkt när menyn öppnas. Safari på iPhone
         hämtar inte alltid lata bilder i en låda som legat utanför
         skärmen, och då blev korten tomma rutor. */
      drawer.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        if (img.closest('.tp2-drawer__tiles')) img.loading = 'eager';
      });
      document.body.classList.add('tp-mobile-drawer-open');
      drawerOpeners.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      shell.classList.remove('is-hidden');
      announceLayer('menu');
      var close = drawer.querySelector('[data-tp2-drawer-close].tp2-iconbtn');
      if (close) window.requestAnimationFrame(function () {
        close.focus({ preventScroll: true });
        resetViewportScroll();
      });
    }

    function closeDrawer(options) {
      if (!drawer || !state.drawer) return;
      state.drawer = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      document.body.classList.remove('tp-mobile-drawer-open');
      drawerOpeners.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      /* återställ till rotnivån efter att lådan glidit ut */
      window.setTimeout(function () {
        if (state.drawer) return;
        resetLevels();
        if (drawerRoot) {
          drawerRoot.classList.remove('is-behind');
          drawerRoot.scrollTop = 0;
        }
      }, 340);
      if (!(options && options.quiet) && drawerLastFocus && typeof drawerLastFocus.focus === 'function') drawerLastFocus.focus();
      drawerLastFocus = null;
    }

    /* Ett lager åt gången (P2-01). Sök, meny och TP Club-ruta stängde redan
       varandra här i headern; varukorgslådan, köpbekräftelsen, snabbköpet
       och popupen visste inte om dem. Alla lager meddelar nu när de öppnas
       (tp:layer-open) och stänger sig när något annat öppnas. */
    document.addEventListener('tp:layer-open', function (event) {
      var name = event.detail && event.detail.name;
      if (name !== 'search') closeSearch({ quiet: true });
      if (name !== 'menu') closeDrawer({ quiet: true });
      closeMega();
    });

    drawerOpeners.forEach(function (button) {
      button.addEventListener('click', function () { openDrawer(button); });
    });

    if (drawer) {
      drawer.querySelectorAll('[data-tp2-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      drawer.querySelectorAll('[data-tp2-drill]').forEach(function (button) {
        button.addEventListener('click', function () { drillTo(button.dataset.tp2Drill); });
      });
      drawer.querySelectorAll('[data-tp2-drill-back]').forEach(function (button) {
        button.addEventListener('click', drillBack);
      });

      /* Kantsvep tillbaka.

         Bara fran vanstra kanten av panelen, som i iOS. Ett svep var som
         helst i lådan skulle krocka med bildraden hogst upp, som scrollar
         i sidled av egen kraft. Ar vi pa rotnivan stanger svepet lådan. */
      var swipe = null;

      drawer.addEventListener('touchstart', function (event) {
        if (!state.drawer || event.touches.length !== 1) return;
        var touch = event.touches[0];
        var panel = drawer.querySelector('.tp2-drawer__panel');
        var left = panel ? panel.getBoundingClientRect().left : 0;
        if (touch.clientX - left > 48) { swipe = null; return; }
        swipe = { x: touch.clientX, y: touch.clientY, used: false };
      }, { passive: true });

      drawer.addEventListener('touchmove', function (event) {
        if (!swipe || swipe.used || event.touches.length !== 1) return;
        var touch = event.touches[0];
        var dx = touch.clientX - swipe.x;
        var dy = Math.abs(touch.clientY - swipe.y);
        if (dx > 56 && dy < 40) {
          swipe.used = true;
          if (levelStack.length) drillBack();
          else closeDrawer();
        }
      }, { passive: true });

      ['touchend', 'touchcancel'].forEach(function (type) {
        drawer.addEventListener(type, function () { swipe = null; }, { passive: true });
      });
    }

    mqDesktop.addEventListener('change', function (event) {
      if (event.matches) closeDrawer();
    });

    /* ------------------------------------------------------------------
       Escape stänger det som är öppet
       ------------------------------------------------------------------ */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (state.drawer) {
        if (levelStack.length) drillBack();
        else closeDrawer();
        return;
      }
      if (state.search) { closeSearch(); return; }
      if (state.mega) closeMega();
    });

    /* ------------------------------------------------------------------
       Scroll — solid header efter hero, göm/visa vid on-scroll-up
       ------------------------------------------------------------------ */
    var lastY = window.scrollY || 0;
    var ticking = false;

    /* Headern klistras av webbläsaren (position: sticky). Scroll-lyssnaren
       byter bara tillstånd — den flyttar ingenting, så logga och ikoner
       står stilla oavsett hur man swipar. */
    function onScroll() {
      var y = window.scrollY || 0;
      shell.classList.toggle('is-scrolled', y > 8);

      if (stickyMode === 'on-scroll-up') {
        var anyOpen = state.mega || state.search || state.drawer;
        if (anyOpen || y < 120) {
          shell.classList.remove('is-hidden');
        } else if (y > lastY + 8) {
          shell.classList.add('is-hidden');
        } else if (y < lastY - 8) {
          shell.classList.remove('is-hidden');
        }
      }

      if (state.mega && Math.abs(y - lastY) > 40) closeMega();
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }, { passive: true });

    window.addEventListener('pageshow', onScroll);
    window.addEventListener('resize', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScroll);
    });
    onScroll();

    /* ------------------------------------------------------------------
       TP Club — samma logik som tidigare header
       ------------------------------------------------------------------ */
    var modal = shell.querySelector('[data-tp-club-modal]');
    if (modal && modal.dataset.tpClubReady !== 'true') {
      modal.dataset.tpClubReady = 'true';

      var clubOpeners = document.querySelectorAll('[data-tp-club-open]');
      var clubClosers = modal.querySelectorAll('[data-tp-club-close]');
      var clubLastTrigger = null;

      var autoEnabled = modal.dataset.tpClubAuto === 'true';
      var delaySeconds = Math.max(0, Number(modal.dataset.tpClubDelay || 7));
      var cooldownDays = Math.max(0, Number(modal.dataset.tpClubCooldown || 7));
      var isMember = modal.dataset.tpClubMember === 'true';
      var storageKey = 'tpClubAutoPopupLastShown';
      var sessionKey = 'tpClubAutoPopupShownThisSession';

      /* Appformularet (Shopify Forms) initieras inte medan rutan ligger dold
         vid sidladdning. Nar rutan oppnas kollar vi darfor om appen faktiskt
         ritat nagot att skriva i. Har den inte gjort det inom en kort stund
         visas temats eget reservformular i stallet, sa att TP Club aldrig
         oppnas som en tom remsa. Ingen slutpunkt och ingen datakalla andras. */
      var clubAppForm = modal.querySelector('[data-tp-club-appform]');
      var clubFallback = modal.querySelector('[data-tp-club-fallback]');
      var clubFallbackSettled = false;

      var clubAppHasField = function () {
        if (!clubAppForm) return false;
        return !!clubAppForm.querySelector('input, textarea, select, iframe');
      };

      var settleClubForm = function () {
        if (clubFallbackSettled || !clubFallback || !clubAppForm) return;
        if (clubAppHasField()) {
          clubFallbackSettled = true;
          return;
        }
        clubFallback.hidden = false;
        if (clubAppForm.parentNode) clubAppForm.hidden = true;
        clubFallbackSettled = true;
      };

      /* Rutan ska vara fardig innan den visas.

         Tidigare kordes settleClubForm() forst NAR modalen oppnades, med 700
         ms marginal at app-formularet. Den som klickade fick darfor se en
         ruta utan formular som byggde klart en sekund senare. Nu avgors det
         i bakgrunden direkt efter sidladdning — appen har anda haft hela
         laddningen pa sig — och kontrollen vid oppning blir bara ett skyddsnat
         for den som hinner klicka inom forsta sekunden. */
      if (clubFallback && clubAppForm) {
        var clubSettleTries = 0;
        var clubSettlePoll = window.setInterval(function () {
          clubSettleTries += 1;
          if (clubAppHasField()) {
            clubFallbackSettled = true;
            window.clearInterval(clubSettlePoll);
            return;
          }
          /* Tio forsok a 300 ms: appen far tre sekunder pa sig innan vi
             bestammer oss for temats eget formular. Da har den antingen
             ritat sitt falt eller sa kommer den inte att gora det. */
          if (clubSettleTries >= 10) {
            window.clearInterval(clubSettlePoll);
            settleClubForm();
          }
        }, 300);
      }

      var openClub = function (trigger) {
        clubLastTrigger = trigger || null;
        closeDrawer();
        modal.hidden = false;
        document.body.classList.add('tp-club-modal-open');
        announceLayer('club');
        if (clubAppHasField()) clubFallbackSettled = true;
        else window.setTimeout(settleClubForm, 700);
        /* Fokus flyttas in i rutan (stangknappen) men inte till
           mejlfaltet: pa mobil fallde tangentbordet annars upp direkt och
           tackte erbjudandet innan kunden hunnit lasa det. */
        window.requestAnimationFrame(function () {
          var close = modal.querySelector('.tp-club-modal__close');
          if (close) close.focus({ preventScroll: true });
        });
      };

      var closeClub = function (options) {
        modal.hidden = true;
        document.body.classList.remove('tp-club-modal-open');
        if (!(options && options.quiet) && clubLastTrigger && typeof clubLastTrigger.focus === 'function') clubLastTrigger.focus();
      };

      document.addEventListener('tp:layer-open', function (event) {
        if (event.detail && event.detail.name !== 'club' && !modal.hidden) closeClub({ quiet: true });
      });

      clubOpeners.forEach(function (button) {
        if (button.dataset.tpClubBound === 'true') return;
        button.dataset.tpClubBound = 'true';
        button.addEventListener('click', function () { openClub(button); });
      });

      clubClosers.forEach(function (button) {
        button.addEventListener('click', closeClub);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) closeClub();
      });

      /* Kvittot i rutan ska bara visas nar det var RUTANS formular som
         skickades.

         Shopifys form.posted_successfully? ar sant for alla kundformular pa
         sidan efter ett inskick — oavsett vilket av dem kunden anvande.
         Tidigare oppnades rutan darfor efter footerns TP Club-falt, quizet
         och bevakningen ocksa, fast kunden redan fatt sitt kvitto dar.

         Ett vanligt inskick kommer tillbaka med formularets id som ankare
         (#TpClubForm). Gick inskicket via Shopifys robotkontroll kan ankaret
         falla bort, sa vi minns aven sjalva att rutans formular skickades
         (sessionStorage, samma nyckel som tp-customer-form.js anvander). */
      var clubForm = modal.querySelector('#TpClubForm');
      var clubPendingKey = 'tpCustomerFormPending';
      if (clubForm) {
        clubForm.addEventListener('submit', function () {
          try { sessionStorage.setItem(clubPendingKey, 'TpClubForm|' + Date.now()); } catch (e) {}
        });
      }

      var customerPosted = window.location.search.indexOf('customer_posted=true') !== -1;
      var clubPosted = false;
      if (customerPosted && modal.querySelector('[data-tp-club-success]')) {
        var clubPending = '';
        try { clubPending = sessionStorage.getItem(clubPendingKey) || ''; } catch (e) {}
        var clubPendingParts = clubPending.split('|');
        var clubPendingFresh = clubPendingParts[0] === 'TpClubForm' &&
          (Date.now() - Number(clubPendingParts[1] || 0)) < 30 * 60 * 1000;
        clubPosted = window.location.hash === '#TpClubForm' || clubPendingFresh;
        if (clubPendingFresh) {
          try { sessionStorage.removeItem(clubPendingKey); } catch (e) {}
        }
      }

      /* Den som just gatt med — via footern, quizet, bevakningen eller
         rutan — ska inte fa erbjudandet att ga med igen. */
      if (customerPosted) {
        try { localStorage.setItem('tpClubJoined', '1'); } catch (e) {}
      }
      try {
        if (localStorage.getItem('tpClubJoined') === '1') isMember = true;
      } catch (e) {}

      if (clubPosted) {
        openClub(null);
      } else if (autoEnabled && !isMember && !(window.Shopify && window.Shopify.designMode)) {
        var shownThisSession = false;
        var lastShown = 0;
        try {
          shownThisSession = sessionStorage.getItem(sessionKey) === '1';
          lastShown = Number(localStorage.getItem(storageKey) || 0);
        } catch (e) {}

        var cooldownMs = cooldownDays * 24 * 60 * 60 * 1000;
        var cooldownPassed = !lastShown || cooldownDays === 0 || (Date.now() - lastShown) >= cooldownMs;

        if (!shownThisSession && cooldownPassed) {
          window.setTimeout(function () {
            if (!modal.hidden) return;
            if (document.body.classList.contains('tp-search-open')) return;
            if (document.body.classList.contains('tp-mobile-drawer-open')) return;
            /* Cookie-docken ligger pa z-index 2147483000 och ar likasa en
               bottensheet. Oppnade auto-popupen bakom den blev resultatet en
               osynlig dialog + scroll-las, dvs sidan sag utfryst ut. Vi satter
               inga flaggor har: rutan far komma vid ett senare sidbyte nar
               samtycket ar hanterat. */
            if (document.body.classList.contains('tp-cookie-visible')) return;
            if (document.querySelector('cart-drawer.active')) return;
            try {
              sessionStorage.setItem(sessionKey, '1');
              localStorage.setItem(storageKey, String(Date.now()));
            } catch (e) {}
            openClub(null);
          }, delaySeconds * 1000);
        }
      }
    }
  }

  /* --------------------------------------------------------------------
     Favoriträknare — oförändrad semantik
     -------------------------------------------------------------------- */
  var favoritesKey = 'tp_favorite_products_v1';

  function readFavorites() {
    try {
      var saved = JSON.parse(localStorage.getItem(favoritesKey) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function updateFavorites() {
    var count = readFavorites().length;
    document.querySelectorAll('[data-tp-favorites-link]').forEach(function (link) {
      var countElement = link.querySelector('[data-tp-favorites-count]');
      link.classList.toggle('has-favorites', count > 0);
      link.setAttribute('aria-label', count > 0 ? 'Dina gillade produkter, ' + count + ' sparade produkter' : 'Dina gillade produkter');
      if (countElement) countElement.textContent = count > 99 ? '99+' : String(count);
    });
  }

  window.addEventListener('storage', function (event) {
    if (event.key === favoritesKey) updateFavorites();
  });
  window.addEventListener('tp:favorites-updated', updateFavorites);

  function boot() {
    document.querySelectorAll('[data-tp2-shell]').forEach(initShell);
    updateFavorites();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
